import React, { createContext, useState } from "react";
import { ContextProviderProps } from "../../../types";
import { RecordsState, UpdateRecordsFunction } from "./records.types";

export const initialState = (): RecordsState => {
  return {
    //Response for drustvoAktivniObjekti

    drustvoAktivniObjekti: [],

    //Response for robneMarkePretraga

    robneMarkePretraga: [],
  };
};

interface IRecordsContext {
  records: RecordsState;
  setRecords: UpdateRecordsFunction;
  clearRecordsState: () => void;
}

export const RecordsContext = createContext<IRecordsContext>(null as any);

export const RecordsContextProvider = ({ children }: ContextProviderProps) => {
  const [records, setRecordsState] = useState(initialState());

  const handleSetRecords = (updatedState: Partial<RecordsState>) => {
    setRecordsState((prev) => ({ ...prev, ...updatedState }));
  };

  const setRecords = (updatedState: Partial<RecordsState>) => {
    handleSetRecords({ ...updatedState });
  };

  const clearRecordsState = () => {
    setRecordsState(initialState());
  };

  return (
    <RecordsContext.Provider
      value={{
        records,
        setRecords,
        clearRecordsState,
      }}
    >
      {children}
    </RecordsContext.Provider>
  );
};
